// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__olM_1","header":"PatientQuestionnaire_header__2Mgdp","info":"PatientQuestionnaire_info__21YvU"};